export const InstitutionFirstApiFlag = 'custody';

// 托管商列表
export const escrowInstitutionList: {
  code: string; // 托管商编码，可与 user/info 接口的source字段里的值进行匹配
  institutionName: string; // 托管商名称，显示给用户的（授权弹窗和API创建成功的确认弹窗里有用）
  customAuthName?: string; // 自定义授权时传给授权接口的托管商名称
  apiNote?: string; // API的默认备注，当该字段有值时，创建API页面的备注一栏不可修改
}[] = [
  {
    code: 'clearloop',
    institutionName: 'Copper',
    customAuthName: 'copper',
    apiNote: 'Copper Binding Key',
  },
  {
    code: 'fireblocks',
    institutionName: 'Fireblocks',
    apiNote: 'Fireblocks Binding Key',
  },
  {
    code: 'bycustody',
    institutionName: 'Custodian',
    apiNote: 'Custodian Binding Key',
  },
  {
    code: 'zodia',
    institutionName: 'Zodia',
    apiNote: 'Zodia Binding Key',
  },
];

export type IEscrowInstitutionCodes =
  (typeof escrowInstitutionList)[number]['code'];

// 托管商code列表
export const escrowInstitutionCodes = escrowInstitutionList.map(
  ({ code }) => code,
);
